var _defs, _rect, _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketingHub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1920,
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 280,
    y1: 640,
    x2: 1200,
    y2: 640,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ff824e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ffa766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 481.9,
    y1: 607.34,
    x2: 1438.1,
    y2: 1312.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ff824e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ff5c35"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1920,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M960,720A240,240,0,0,0,720,960v640a240,240,0,0,0,437.77,136l440-640a240,240,0,0,0-197-376Z",
    fill: "#ff5c35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M960,1200a240,240,0,0,0,240-240V320a240,240,0,0,0-437.77-136l-440,640A240,240,0,0,0,520,1200Z",
    fill: "url(#a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 320,
    r: 240,
    fill: "#ff5c35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1400,1200H520a240,240,0,1,1,0-480h880a240,240,0,1,1,0,480Z",
    fill: "url(#b)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingHub);
export default __webpack_public_path__ + "static/media/MarketingHub.ed2c3718d8e76fbeadf67475b7e1742d.svg";
export { ForwardRef as ReactComponent };